import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setSelectedBrandConfigs,
  setSelectedBusinessAdvisorDestinationTableId,
  setSelectedUnifierDestinationTableId,
} from "../../../../../features/dataCollectionBrandsSlice";

const ProcessSetting = () => {
  const [expandedInput, setExpandedInput] = useState<string | false>(false);
  const dispatch = useDispatch();
  const {
    brandDataInModal,
    startDate,
    endDate,
    selectedBrandConfigs,
    selectedAction,
    selectedUnifierDestinationTableId,
    selectedBusinessAdvisorDestinationTableId,
  } = useSelector((state: any) => state.dataCollectionBrands);

  const handleCheckboxChange =
    (brandId: string, brandName: string, configName: string, tableId: string) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(
        setSelectedBrandConfigs({
          brandId,
          brandName,
          configName,
          tableId,
          checked: event.target.checked,
        })
      );
    };

  const unifierStaticConfigs = [
    { destinationTableId: 2, configName: "Brand Performance" },
    { destinationTableId: 4, configName: "User Performance" },
    { destinationTableId: 1, configName: "Monthly Brand Performance" },
  ];

  const businessAdvisorStaticConfigs = [
    { destinationTableId: 2, configName: "Final Brand Performance" },
    { destinationTableId: 3, configName: "Final User Performance" },
    { destinationTableId: 1, configName: "Final Monthly Brand Performance" },
  ];
  const isChecked = (brandId: string, tableId: string) => {
    return (
      selectedBrandConfigs
        ?.find((b: any) => b.brandId === brandId)
        ?.selectedConfigs?.some((c: any) => c.tableId === tableId) || false
    );
  };
  const isUnifierChecked = (destinationTableId: number) => {
    return selectedUnifierDestinationTableId.some(
      (c: any) => c.destinationTableId === destinationTableId
    );
  };
  const isBusinessAdvisorChecked = (destinationTableId: number) => {
    return selectedBusinessAdvisorDestinationTableId.some(
      (c: any) => c.destinationTableId === destinationTableId
    );
  };
  const handleChangeInput =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedInput(isExpanded ? panel : false);
    };
  const formatDateForUI = (dateStr: string) => {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // fallback if invalid
    return date.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  };
  return (
    <Box>
      <Stack flexDirection={"row"} gap={2} mt={2}>
        <Typography fontWeight="500">
          Start Date:{" "}
          <Typography component="span">{formatDateForUI(startDate)}</Typography>
        </Typography>
        <Typography fontWeight="500">
          End Date:{" "}
          <Typography component="span">{formatDateForUI(endDate)}</Typography>
        </Typography>
      </Stack>
      <Box mt={2}>
        {selectedAction === "Fetcher" ? (
          <Typography fontWeight={500}>Fetcher Settings: </Typography>
        ) : (
          <Typography fontWeight={500}>Unifier Settings: </Typography>
        )}

        <Stack gap={2} mt={2}>
          <Grid container spacing={2}>
            <Grid size={12}>
              {brandDataInModal?.map((brand: any, index: any) => (
                <Accordion
                  key={brand.brandId}
                  expanded={expandedInput === `panel${index}`}
                  onChange={handleChangeInput(`panel${index}`)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <Typography
                      component="span"
                      sx={{ width: "33%", flexShrink: 0 }}
                    >
                      {brand.brandName}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack flexDirection={"column"}>
                      {selectedAction === "Fetcher" ? (
                        <Grid container spacing={1}>
                          {brand.row_output_table_data.map((tableData: any) => (
                            <Grid key={tableData.table_id} size={4}>
                              <FormControlLabel
                                id={`outlined-${tableData.config_name
                                  .toLowerCase()
                                  .replace(" ", "-")}`}
                                label={`${tableData.config_name} (${tableData.table_id})`} // Format as "config_name (table_id)"
                                control={
                                  <Checkbox
                                    color="secondary"
                                    onChange={handleCheckboxChange(
                                      brand.brandId,
                                      brand.brandName,
                                      tableData.config_name,
                                      tableData.table_id
                                    )}
                                    checked={isChecked(
                                      brand.brandId,
                                      tableData.table_id
                                    )}
                                  />
                                }
                              />
                            </Grid>
                          ))}
                        </Grid>
                      ) : selectedAction === "business_advisor" ? (
                        <Grid container spacing={1}>
                          {businessAdvisorStaticConfigs.map(
                            ({ configName, destinationTableId }) => (
                              <Grid key={destinationTableId} size={4}>
                                <FormControlLabel
                                  label={`${configName}`}
                                  control={
                                    <Checkbox
                                      color="secondary"
                                      checked={isBusinessAdvisorChecked(
                                        destinationTableId
                                      )}
                                      onChange={(e) =>
                                        dispatch(
                                          setSelectedBusinessAdvisorDestinationTableId(
                                            {
                                              destinationTableId,
                                              configName,
                                              checked: e.target.checked,
                                            }
                                          )
                                        )
                                      }
                                    />
                                  }
                                />
                              </Grid>
                            )
                          )}
                        </Grid>
                      ) : (
                        <Grid container spacing={1}>
                          {unifierStaticConfigs.map(
                            ({ configName, destinationTableId }) => (
                              <Grid key={destinationTableId} size={4}>
                                <FormControlLabel
                                  label={`${configName}`}
                                  control={
                                    <Checkbox
                                      color="secondary"
                                      checked={isUnifierChecked(
                                        destinationTableId
                                      )}
                                      onChange={(e) =>
                                        dispatch(
                                          setSelectedUnifierDestinationTableId({
                                            destinationTableId,
                                            configName,
                                            checked: e.target.checked,
                                          })
                                        )
                                      }
                                    />
                                  }
                                />
                              </Grid>
                            )
                          )}
                        </Grid>
                      )}
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Box>
  );
};

export default ProcessSetting;
